import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { PrimeNG } from 'primeng/config';

@Injectable({ providedIn: 'root' })
export class PrimeNGTranslationService {
  private transloco = inject(TranslocoService);
  private primeng = inject(PrimeNG);

  updateTranslations() {
    this.transloco.selectTranslation().subscribe({
      next: (translations) => {
        this.setTranslations();
      }
    });

    // Initialiser immédiatement aussi
    this.setTranslations();
  }

  private setTranslations() {
    // console.log('Setting PrimeNG translations...');
    // console.log('startsWith value:', this.transloco.translate('primeng.startsWith'));

    this.primeng.setTranslation({
      startsWith: this.transloco.translate('primeng.startsWith'),
      contains: this.transloco.translate('primeng.contains'),
      notContains: this.transloco.translate('primeng.notContains'),
      endsWith: this.transloco.translate('primeng.endsWith'),
      equals: this.transloco.translate('primeng.equals'),
      completed: this.transloco.translate('primeng.completed'),
      notEquals: this.transloco.translate('primeng.notEquals'),
      noFilter: this.transloco.translate('primeng.noFilter'),
      lt: this.transloco.translate('primeng.lt'),
      lte: this.transloco.translate('primeng.lte'),
      gt: this.transloco.translate('primeng.gt'),
      gte: this.transloco.translate('primeng.gte'),
      is: this.transloco.translate('primeng.is'),
      isNot: this.transloco.translate('primeng.isNot'),
      before: this.transloco.translate('primeng.before'),
      after: this.transloco.translate('primeng.after'),
      dateIs: this.transloco.translate('primeng.dateIs'),
      dateIsNot: this.transloco.translate('primeng.dateIsNot'),
      dateBefore: this.transloco.translate('primeng.dateBefore'),
      dateAfter: this.transloco.translate('primeng.dateAfter'),
      clear: this.transloco.translate('primeng.clear'),
      apply: this.transloco.translate('primeng.apply'),
      matchAll: this.transloco.translate('primeng.matchAll'),
      matchAny: this.transloco.translate('primeng.matchAny'),
      addRule: this.transloco.translate('primeng.addRule'),
      removeRule: this.transloco.translate('primeng.removeRule'),
      accept: this.transloco.translate('primeng.accept'),
      reject: this.transloco.translate('primeng.reject'),
      choose: this.transloco.translate('primeng.choose'),
      upload: this.transloco.translate('primeng.upload'),
      cancel: this.transloco.translate('primeng.cancel'),
      fileSizeTypes: this.transloco.translate('primeng.fileSizeTypes'),
      dayNames: this.transloco.translate('primeng.dayNames'),
      dayNamesShort: this.transloco.translate('primeng.dayNamesShort'),
      dayNamesMin: this.transloco.translate('primeng.dayNamesMin'),
      monthNames: this.transloco.translate('primeng.monthNames'),
      monthNamesShort: this.transloco.translate('primeng.monthNamesShort'),
      dateFormat: this.transloco.translate('primeng.dateFormat'),
      firstDayOfWeek: parseInt(this.transloco.translate('primeng.firstDayOfWeek')),
      today: this.transloco.translate('primeng.today'),
      weekHeader: this.transloco.translate('primeng.weekHeader'),
      weak: this.transloco.translate('primeng.weak'),
      medium: this.transloco.translate('primeng.medium'),
      strong: this.transloco.translate('primeng.strong'),
      passwordPrompt: this.transloco.translate('primeng.passwordPrompt'),
      emptyMessage: this.transloco.translate('primeng.emptyMessage'),
      emptyFilterMessage: this.transloco.translate('primeng.emptyFilterMessage'),
      fileChosenMessage: this.transloco.translate('primeng.fileChosenMessage'),
      noFileChosenMessage: this.transloco.translate('primeng.noFileChosenMessage'),
      pending: this.transloco.translate('primeng.pending'),
      chooseYear: this.transloco.translate('primeng.chooseYear'),
      chooseMonth: this.transloco.translate('primeng.chooseMonth'),
      chooseDate: this.transloco.translate('primeng.chooseDate'),
      prevDecade: this.transloco.translate('primeng.prevDecade'),
      nextDecade: this.transloco.translate('primeng.nextDecade'),
      prevYear: this.transloco.translate('primeng.prevYear'),
      nextYear: this.transloco.translate('primeng.nextYear'),
      prevMonth: this.transloco.translate('primeng.prevMonth'),
      nextMonth: this.transloco.translate('primeng.nextMonth'),
      prevHour: this.transloco.translate('primeng.prevHour'),
      nextHour: this.transloco.translate('primeng.nextHour'),
      prevMinute: this.transloco.translate('primeng.prevMinute'),
      nextMinute: this.transloco.translate('primeng.nextMinute'),
      prevSecond: this.transloco.translate('primeng.prevSecond'),
      nextSecond: this.transloco.translate('primeng.nextSecond'),
      am: this.transloco.translate('primeng.am'),
      pm: this.transloco.translate('primeng.pm'),
      searchMessage: this.transloco.translate('primeng.searchMessage'),
      selectionMessage: this.transloco.translate('primeng.selectionMessage'),
      emptySelectionMessage: this.transloco.translate('primeng.emptySelectionMessage'),
      emptySearchMessage: this.transloco.translate('primeng.emptySearchMessage')

    });
  }
}
